import AccessTimeIcon from '@/assets/icons/access-time-white.svg?react';
import { ServiceReservationGuide } from '@/components/ServiceReservationGuide';
import {
    CENTER_RESERVATION_AVAILABLE_TIME_LABEL,
    CENTER_RESERVATION_TIME_RESTRICTED_MESSAGE,
} from '@/utils/centerServiceAvailability';

export function ReservationTimeRestrictedGuide() {
    return (
        <ServiceReservationGuide
            icon={<AccessTimeIcon className="icon-svg" />}
            title="예약 가능 시간 안내"
            description={CENTER_RESERVATION_TIME_RESTRICTED_MESSAGE}
            detailLabel="예약 가능 시간"
            detailValue={CENTER_RESERVATION_AVAILABLE_TIME_LABEL}
            iconBackgroundColor="#002677"
        />
    );
}
